//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AuthorizedApiBase {
    authToken = '';

    targetOrganisation = sessionStorage.getItem('targetOrganisation');

    setAuthToken(token: string) {
        this.authToken = token;
    }

    protected transformOptions(options: any): Promise<any> {
        if (this.authToken && this.authToken !== '') {
            options.headers = { ...options.headers, Authorization: `Bearer ${this.authToken}` };
        }

        if (this.targetOrganisation) {
            const targetOrganisationJson = JSON.parse(this.targetOrganisation);
            if (targetOrganisationJson && targetOrganisationJson.targetOrganisationAbn) {
                options.headers = {
                    ...options.headers,
                    TargetOrganisationAbn: `${targetOrganisationJson.targetOrganisationAbn}`,
                };
            }
        }
        return Promise.resolve(options);
    }
}

export class AddressClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    search(keyword: string | null | undefined, signal?: AbortSignal): Promise<MatchedAddressesDto> {
        let url_ = this.baseUrl + "/api/address/search?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<MatchedAddressesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MatchedAddressesDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchedAddressesDto>(null as any);
    }
}

export class ApplicationClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    createApplication(command: CreateApplicationCommand, signal?: AbortSignal): Promise<ApplicationDto> {
        let url_ = this.baseUrl + "/api/application";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateApplication(_response);
        });
    }

    protected processCreateApplication(response: Response): Promise<ApplicationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationDto>(null as any);
    }

    copyApplication(referenceId: string, command: CopyApplicationCommand, signal?: AbortSignal): Promise<ApplicationDto> {
        let url_ = this.baseUrl + "/api/application/{ReferenceId}/copy";
        if (referenceId === undefined || referenceId === null)
            throw new globalThis.Error("The parameter 'referenceId' must be defined.");
        url_ = url_.replace("{ReferenceId}", encodeURIComponent("" + referenceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCopyApplication(_response);
        });
    }

    protected processCopyApplication(response: Response): Promise<ApplicationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationDto>(null as any);
    }

    deleteApplication(referenceId: string, command: DeleteApplicationCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/application/{ReferenceId}/delete";
        if (referenceId === undefined || referenceId === null)
            throw new globalThis.Error("The parameter 'referenceId' must be defined.");
        url_ = url_.replace("{ReferenceId}", encodeURIComponent("" + referenceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteApplication(_response);
        });
    }

    protected processDeleteApplication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ContactClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getUserContact(query: GetUserContactQuery | null | undefined, signal?: AbortSignal): Promise<ContactFormStep> {
        let url_ = this.baseUrl + "/api/contact/usercontact?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserContact(_response);
        });
    }

    protected processGetUserContact(response: Response): Promise<ContactFormStep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactFormStep;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactFormStep>(null as any);
    }

    saveContactDetails(command: SaveContactCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/contact/save-contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveContactDetails(_response);
        });
    }

    protected processSaveContactDetails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DashboardClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getQuotesForDefaultOrganisation(signal?: AbortSignal): Promise<DashboardItemDto[]> {
        let url_ = this.baseUrl + "/api/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuotesForDefaultOrganisation(_response);
        });
    }

    protected processGetQuotesForDefaultOrganisation(response: Response): Promise<DashboardItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardItemDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardItemDto[]>(null as any);
    }

    getDashboardQuotesByPortalID(portalId: string | undefined, year: string | null | undefined, status: StatusEnumDto | null | undefined, sortOrder: string | null | undefined, searchText: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, signal?: AbortSignal): Promise<PagedListOfDashboardItemDto> {
        let url_ = this.baseUrl + "/api/dashboard/get-filtered-dashboard-quotes?";
        if (portalId === null)
            throw new globalThis.Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "PortalId=" + encodeURIComponent("" + portalId) + "&";
        if (year !== undefined && year !== null)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDashboardQuotesByPortalID(_response);
        });
    }

    protected processGetDashboardQuotesByPortalID(response: Response): Promise<PagedListOfDashboardItemDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListOfDashboardItemDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedListOfDashboardItemDto>(null as any);
    }

    getDashboardDraftsByPortalID(portalId: string | undefined, year: string | null | undefined, status: StatusEnumDto | null | undefined, sortOrder: string | null | undefined, searchText: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, signal?: AbortSignal): Promise<PagedListOfDashboardItemDto> {
        let url_ = this.baseUrl + "/api/dashboard/get-filtered-dashboard-drafts?";
        if (portalId === null)
            throw new globalThis.Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "PortalId=" + encodeURIComponent("" + portalId) + "&";
        if (year !== undefined && year !== null)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDashboardDraftsByPortalID(_response);
        });
    }

    protected processGetDashboardDraftsByPortalID(response: Response): Promise<PagedListOfDashboardItemDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListOfDashboardItemDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedListOfDashboardItemDto>(null as any);
    }

    getDashboardArtefactsByPortalID(portalId: string | undefined, year: string | null | undefined, status: StatusEnumDto | null | undefined, sortOrder: string | null | undefined, searchText: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, signal?: AbortSignal): Promise<PagedListOfDashboardItemDto> {
        let url_ = this.baseUrl + "/api/dashboard/get-filtered-dashboard-artefacts?";
        if (portalId === null)
            throw new globalThis.Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "PortalId=" + encodeURIComponent("" + portalId) + "&";
        if (year !== undefined && year !== null)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDashboardArtefactsByPortalID(_response);
        });
    }

    protected processGetDashboardArtefactsByPortalID(response: Response): Promise<PagedListOfDashboardItemDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListOfDashboardItemDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedListOfDashboardItemDto>(null as any);
    }

    getDashboardInstrumentArtefactReportsByPortalIDAndArtefactName(portalId: string | undefined, name: string | undefined, pageSize: number | undefined, pageNumber: number | undefined, signal?: AbortSignal): Promise<PagedListOfInstrumentArtefactDto> {
        let url_ = this.baseUrl + "/api/dashboard/get-dashboard-instrument-artefact-reports?";
        if (portalId === null)
            throw new globalThis.Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "PortalId=" + encodeURIComponent("" + portalId) + "&";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDashboardInstrumentArtefactReportsByPortalIDAndArtefactName(_response);
        });
    }

    protected processGetDashboardInstrumentArtefactReportsByPortalIDAndArtefactName(response: Response): Promise<PagedListOfInstrumentArtefactDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListOfInstrumentArtefactDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedListOfInstrumentArtefactDto>(null as any);
    }

    getQuoteOfferPDFByQuoteID(quoteID: string | undefined, returnFile: boolean | null | undefined, signal?: AbortSignal): Promise<DownloadedFileResponse> {
        let url_ = this.baseUrl + "/api/dashboard/get-quote-offer-pdf?";
        if (quoteID === null)
            throw new globalThis.Error("The parameter 'quoteID' cannot be null.");
        else if (quoteID !== undefined)
            url_ += "QuoteID=" + encodeURIComponent("" + quoteID) + "&";
        if (returnFile !== undefined && returnFile !== null)
            url_ += "ReturnFile=" + encodeURIComponent("" + returnFile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuoteOfferPDFByQuoteID(_response);
        });
    }

    protected processGetQuoteOfferPDFByQuoteID(response: Response): Promise<DownloadedFileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadedFileResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadedFileResponse>(null as any);
    }

    getQuoteRequestAcceptedPDFByID(quoteRequestID: string | undefined, returnFile: boolean | null | undefined, signal?: AbortSignal): Promise<DownloadedFileResponse> {
        let url_ = this.baseUrl + "/api/dashboard/get-quote-request-accepted-pdf?";
        if (quoteRequestID === null)
            throw new globalThis.Error("The parameter 'quoteRequestID' cannot be null.");
        else if (quoteRequestID !== undefined)
            url_ += "QuoteRequestID=" + encodeURIComponent("" + quoteRequestID) + "&";
        if (returnFile !== undefined && returnFile !== null)
            url_ += "ReturnFile=" + encodeURIComponent("" + returnFile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuoteRequestAcceptedPDFByID(_response);
        });
    }

    protected processGetQuoteRequestAcceptedPDFByID(response: Response): Promise<DownloadedFileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadedFileResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadedFileResponse>(null as any);
    }

    getQuoteRequestRejectedPDFByID(quoteRequestID: string | undefined, returnFile: boolean | null | undefined, signal?: AbortSignal): Promise<DownloadedFileResponse> {
        let url_ = this.baseUrl + "/api/dashboard/get-quote-request-rejected-pdf?";
        if (quoteRequestID === null)
            throw new globalThis.Error("The parameter 'quoteRequestID' cannot be null.");
        else if (quoteRequestID !== undefined)
            url_ += "QuoteRequestID=" + encodeURIComponent("" + quoteRequestID) + "&";
        if (returnFile !== undefined && returnFile !== null)
            url_ += "ReturnFile=" + encodeURIComponent("" + returnFile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuoteRequestRejectedPDFByID(_response);
        });
    }

    protected processGetQuoteRequestRejectedPDFByID(response: Response): Promise<DownloadedFileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadedFileResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadedFileResponse>(null as any);
    }

    getQuoteReportPDFByID(quoteRequestID: string | undefined, returnFile: boolean | null | undefined, signal?: AbortSignal): Promise<DownloadedFileResponse> {
        let url_ = this.baseUrl + "/api/dashboard/get-quote-report-pdf?";
        if (quoteRequestID === null)
            throw new globalThis.Error("The parameter 'quoteRequestID' cannot be null.");
        else if (quoteRequestID !== undefined)
            url_ += "QuoteRequestID=" + encodeURIComponent("" + quoteRequestID) + "&";
        if (returnFile !== undefined && returnFile !== null)
            url_ += "ReturnFile=" + encodeURIComponent("" + returnFile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuoteReportPDFByID(_response);
        });
    }

    protected processGetQuoteReportPDFByID(response: Response): Promise<DownloadedFileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadedFileResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadedFileResponse>(null as any);
    }
}

export class FileClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    fetchBytesFromUrl(url: string | null | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/file/fetch-accessible-form?";
        if (url !== undefined && url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFetchBytesFromUrl(_response);
        });
    }

    protected processFetchBytesFromUrl(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class LookupClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getLookup(lookupType: CRMLookupTypes | undefined, signal?: AbortSignal): Promise<LookupResponse[]> {
        let url_ = this.baseUrl + "/api/lookup?";
        if (lookupType === null)
            throw new globalThis.Error("The parameter 'lookupType' cannot be null.");
        else if (lookupType !== undefined)
            url_ += "LookupType=" + encodeURIComponent("" + lookupType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLookup(_response);
        });
    }

    protected processGetLookup(response: Response): Promise<LookupResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookupResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupResponse[]>(null as any);
    }

    getArtefactType(measurementCategoryId: string | undefined, signal?: AbortSignal): Promise<LookupResponse[]> {
        let url_ = this.baseUrl + "/api/lookup/artefact-type?";
        if (measurementCategoryId === null)
            throw new globalThis.Error("The parameter 'measurementCategoryId' cannot be null.");
        else if (measurementCategoryId !== undefined)
            url_ += "MeasurementCategoryId=" + encodeURIComponent("" + measurementCategoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetArtefactType(_response);
        });
    }

    protected processGetArtefactType(response: Response): Promise<LookupResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookupResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupResponse[]>(null as any);
    }

    getServices(signal?: AbortSignal): Promise<ServiceDto[]> {
        let url_ = this.baseUrl + "/api/lookup/services";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetServices(_response);
        });
    }

    protected processGetServices(response: Response): Promise<ServiceDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceDto[]>(null as any);
    }

    getNmiApplication(signal?: AbortSignal): Promise<LookupResponse[]> {
        let url_ = this.baseUrl + "/api/lookup/nmi-application";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNmiApplication(_response);
        });
    }

    protected processGetNmiApplication(response: Response): Promise<LookupResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookupResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupResponse[]>(null as any);
    }

    getInfoPanelContent(instrumentTypeId: string | undefined, instrumentCategoryId: string | undefined, signal?: AbortSignal): Promise<InstrumentTypeContentDto[]> {
        let url_ = this.baseUrl + "/api/lookup/info-panel-content?";
        if (instrumentTypeId === null)
            throw new globalThis.Error("The parameter 'instrumentTypeId' cannot be null.");
        else if (instrumentTypeId !== undefined)
            url_ += "InstrumentTypeId=" + encodeURIComponent("" + instrumentTypeId) + "&";
        if (instrumentCategoryId === null)
            throw new globalThis.Error("The parameter 'instrumentCategoryId' cannot be null.");
        else if (instrumentCategoryId !== undefined)
            url_ += "InstrumentCategoryId=" + encodeURIComponent("" + instrumentCategoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInfoPanelContent(_response);
        });
    }

    protected processGetInfoPanelContent(response: Response): Promise<InstrumentTypeContentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstrumentTypeContentDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentTypeContentDto[]>(null as any);
    }

    getAllInfoPanelContent(query: AllInfoPanelContentQuery | null | undefined, signal?: AbortSignal): Promise<InstrumentTypeContentDto[]> {
        let url_ = this.baseUrl + "/api/lookup/all-info-panel-content?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllInfoPanelContent(_response);
        });
    }

    protected processGetAllInfoPanelContent(response: Response): Promise<InstrumentTypeContentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstrumentTypeContentDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentTypeContentDto[]>(null as any);
    }
}

export class OrganisationsClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getOrganisationsByABN(abn: string | undefined, isCompleted: boolean | null | undefined, signal?: AbortSignal): Promise<OrganisationDto[]> {
        let url_ = this.baseUrl + "/api/organisations/byabn?";
        if (abn === null)
            throw new globalThis.Error("The parameter 'abn' cannot be null.");
        else if (abn !== undefined)
            url_ += "abn=" + encodeURIComponent("" + abn) + "&";
        if (isCompleted !== undefined && isCompleted !== null)
            url_ += "isCompleted=" + encodeURIComponent("" + isCompleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrganisationsByABN(_response);
        });
    }

    protected processGetOrganisationsByABN(response: Response): Promise<OrganisationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganisationDto[]>(null as any);
    }
}

export class PatternApprovalClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getPatternApprovalApplications(portalOrgId: string | null | undefined, year: string | null | undefined, status: PatternApprovalStatusEnumDto | null | undefined, sortOrder: string | null | undefined, searchText: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, signal?: AbortSignal): Promise<PagedListOfPatternApprovalDashboardDetailsDto> {
        let url_ = this.baseUrl + "/api/pattern-approval/get-pattern-approval-dashboard-applications?";
        if (portalOrgId !== undefined && portalOrgId !== null)
            url_ += "PortalOrgId=" + encodeURIComponent("" + portalOrgId) + "&";
        if (year !== undefined && year !== null)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPatternApprovalApplications(_response);
        });
    }

    protected processGetPatternApprovalApplications(response: Response): Promise<PagedListOfPatternApprovalDashboardDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListOfPatternApprovalDashboardDetailsDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedListOfPatternApprovalDashboardDetailsDto>(null as any);
    }

    getPatternApprovalApplicationDrafts(portalOrgId: string | null | undefined, year: string | null | undefined, status: PatternApprovalStatusEnumDto | null | undefined, sortOrder: string | null | undefined, searchText: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, signal?: AbortSignal): Promise<PagedListOfPatternApprovalDashboardDetailsDto> {
        let url_ = this.baseUrl + "/api/pattern-approval/get-pattern-approval-dashboard-drafts?";
        if (portalOrgId !== undefined && portalOrgId !== null)
            url_ += "PortalOrgId=" + encodeURIComponent("" + portalOrgId) + "&";
        if (year !== undefined && year !== null)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPatternApprovalApplicationDrafts(_response);
        });
    }

    protected processGetPatternApprovalApplicationDrafts(response: Response): Promise<PagedListOfPatternApprovalDashboardDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListOfPatternApprovalDashboardDetailsDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedListOfPatternApprovalDashboardDetailsDto>(null as any);
    }
}

export class ProgressClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getProgressUploadId(signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/progress";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProgressUploadId(_response);
        });
    }

    protected processGetProgressUploadId(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getProgress(uploadId: string, lastPercent: number | undefined, signal?: AbortSignal): Promise<UploadProgress> {
        let url_ = this.baseUrl + "/api/progress/{uploadId}?";
        if (uploadId === undefined || uploadId === null)
            throw new globalThis.Error("The parameter 'uploadId' must be defined.");
        url_ = url_.replace("{uploadId}", encodeURIComponent("" + uploadId));
        if (lastPercent === null)
            throw new globalThis.Error("The parameter 'lastPercent' cannot be null.");
        else if (lastPercent !== undefined)
            url_ += "lastPercent=" + encodeURIComponent("" + lastPercent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProgress(_response);
        });
    }

    protected processGetProgress(response: Response): Promise<UploadProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UploadProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadProgress>(null as any);
    }

    cancelFile(uploadId: string, fileName: string, signal?: AbortSignal): Promise<ProgressCancelDto> {
        let url_ = this.baseUrl + "/api/progress/{uploadId}/files/{fileName}";
        if (uploadId === undefined || uploadId === null)
            throw new globalThis.Error("The parameter 'uploadId' must be defined.");
        url_ = url_.replace("{uploadId}", encodeURIComponent("" + uploadId));
        if (fileName === undefined || fileName === null)
            throw new globalThis.Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelFile(_response);
        });
    }

    protected processCancelFile(response: Response): Promise<ProgressCancelDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProgressCancelDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProgressCancelDto>(null as any);
    }

    deleteProgressStatistics(uploadId: string, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/progress/{uploadId}/delete";
        if (uploadId === undefined || uploadId === null)
            throw new globalThis.Error("The parameter 'uploadId' must be defined.");
        url_ = url_.replace("{uploadId}", encodeURIComponent("" + uploadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteProgressStatistics(_response);
        });
    }

    protected processDeleteProgressStatistics(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class QuoteClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getQuoteRequestDetails(quoteRequestID: string | undefined, signal?: AbortSignal): Promise<RequestForQuoteDetails> {
        let url_ = this.baseUrl + "/api/quote/get-quote-request-details?";
        if (quoteRequestID === null)
            throw new globalThis.Error("The parameter 'quoteRequestID' cannot be null.");
        else if (quoteRequestID !== undefined)
            url_ += "QuoteRequestID=" + encodeURIComponent("" + quoteRequestID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuoteRequestDetails(_response);
        });
    }

    protected processGetQuoteRequestDetails(response: Response): Promise<RequestForQuoteDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequestForQuoteDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestForQuoteDetails>(null as any);
    }

    getQuoteRequestDetailsByRefId(applicationType: ApplicationType | undefined, quoteReferenceID: string | null | undefined, signal?: AbortSignal): Promise<RequestForQuoteDetails> {
        let url_ = this.baseUrl + "/api/quote/get-quote-request-details-byrefid?";
        if (applicationType === null)
            throw new globalThis.Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "ApplicationType=" + encodeURIComponent("" + applicationType) + "&";
        if (quoteReferenceID !== undefined && quoteReferenceID !== null)
            url_ += "QuoteReferenceID=" + encodeURIComponent("" + quoteReferenceID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuoteRequestDetailsByRefId(_response);
        });
    }

    protected processGetQuoteRequestDetailsByRefId(response: Response): Promise<RequestForQuoteDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequestForQuoteDetails;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestForQuoteDetails>(null as any);
    }

    declineQuote(quoteRequestId: string | undefined, firstName: string | undefined, lastName: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/quote/decline-quote?";
        if (quoteRequestId === null)
            throw new globalThis.Error("The parameter 'quoteRequestId' cannot be null.");
        else if (quoteRequestId !== undefined)
            url_ += "QuoteRequestId=" + encodeURIComponent("" + quoteRequestId) + "&";
        if (firstName === null)
            throw new globalThis.Error("The parameter 'firstName' cannot be null.");
        else if (firstName !== undefined)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName === null)
            throw new globalThis.Error("The parameter 'lastName' cannot be null.");
        else if (lastName !== undefined)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeclineQuote(_response);
        });
    }

    protected processDeclineQuote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UsersClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    signIn(command: SignInCommand, signal?: AbortSignal): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/users/sign-in";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSignIn(_response);
        });
    }

    protected processSignIn(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    acceptTermsAndCondition(command: AcceptTermsAndConditionsCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/users/accept-terms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAcceptTermsAndCondition(_response);
        });
    }

    protected processAcceptTermsAndCondition(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    setDefaultOrganisation(command: SetDefaultOrganisationCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/users/set-default-organisation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetDefaultOrganisation(_response);
        });
    }

    protected processSetDefaultOrganisation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    setUserProfile(userProfile_FirstName: string | null | undefined, userProfile_LastName: string | null | undefined, userProfile_Email: string | null | undefined, userProfile_Services: ServicesOffered[] | undefined, userProfile_TestingCalibrationDashboard_FilterStatus: string | null | undefined, userProfile_TestingCalibrationDashboard_FilterYear: string | null | undefined, userProfile_TestingCalibrationDashboard_FilterSortOrder: string | null | undefined, userProfile_TestingCalibrationDashboard_FiltersChanged: boolean | null | undefined, userProfile_TestingCalibrationDashboard_FilterCurrentPage: number | undefined, userProfile_TestingCalibrationDashboard_FilterActiveTab: string | null | undefined, userProfile_TestingCalibrationDashboard_FilterSearchText: string | null | undefined, userProfile_PatternApprovalDashboard_FilterStatus: string | null | undefined, userProfile_PatternApprovalDashboard_FilterYear: string | null | undefined, userProfile_PatternApprovalDashboard_FilterSortOrder: string | null | undefined, userProfile_PatternApprovalDashboard_FiltersChanged: boolean | null | undefined, userProfile_PatternApprovalDashboard_FilterCurrentPage: number | undefined, userProfile_PatternApprovalDashboard_FilterActiveTab: string | null | undefined, userProfile_PatternApprovalDashboard_FilterSearchText: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/users/set-userprofile?";
        if (userProfile_FirstName !== undefined && userProfile_FirstName !== null)
            url_ += "UserProfile.FirstName=" + encodeURIComponent("" + userProfile_FirstName) + "&";
        if (userProfile_LastName !== undefined && userProfile_LastName !== null)
            url_ += "UserProfile.LastName=" + encodeURIComponent("" + userProfile_LastName) + "&";
        if (userProfile_Email !== undefined && userProfile_Email !== null)
            url_ += "UserProfile.Email=" + encodeURIComponent("" + userProfile_Email) + "&";
        if (userProfile_Services === null)
            throw new globalThis.Error("The parameter 'userProfile_Services' cannot be null.");
        else if (userProfile_Services !== undefined)
            userProfile_Services && userProfile_Services.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "UserProfile.Services[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (userProfile_TestingCalibrationDashboard_FilterStatus !== undefined && userProfile_TestingCalibrationDashboard_FilterStatus !== null)
            url_ += "UserProfile.TestingCalibrationDashboard.FilterStatus=" + encodeURIComponent("" + userProfile_TestingCalibrationDashboard_FilterStatus) + "&";
        if (userProfile_TestingCalibrationDashboard_FilterYear !== undefined && userProfile_TestingCalibrationDashboard_FilterYear !== null)
            url_ += "UserProfile.TestingCalibrationDashboard.FilterYear=" + encodeURIComponent("" + userProfile_TestingCalibrationDashboard_FilterYear) + "&";
        if (userProfile_TestingCalibrationDashboard_FilterSortOrder !== undefined && userProfile_TestingCalibrationDashboard_FilterSortOrder !== null)
            url_ += "UserProfile.TestingCalibrationDashboard.FilterSortOrder=" + encodeURIComponent("" + userProfile_TestingCalibrationDashboard_FilterSortOrder) + "&";
        if (userProfile_TestingCalibrationDashboard_FiltersChanged !== undefined && userProfile_TestingCalibrationDashboard_FiltersChanged !== null)
            url_ += "UserProfile.TestingCalibrationDashboard.FiltersChanged=" + encodeURIComponent("" + userProfile_TestingCalibrationDashboard_FiltersChanged) + "&";
        if (userProfile_TestingCalibrationDashboard_FilterCurrentPage === null)
            throw new globalThis.Error("The parameter 'userProfile_TestingCalibrationDashboard_FilterCurrentPage' cannot be null.");
        else if (userProfile_TestingCalibrationDashboard_FilterCurrentPage !== undefined)
            url_ += "UserProfile.TestingCalibrationDashboard.FilterCurrentPage=" + encodeURIComponent("" + userProfile_TestingCalibrationDashboard_FilterCurrentPage) + "&";
        if (userProfile_TestingCalibrationDashboard_FilterActiveTab !== undefined && userProfile_TestingCalibrationDashboard_FilterActiveTab !== null)
            url_ += "UserProfile.TestingCalibrationDashboard.FilterActiveTab=" + encodeURIComponent("" + userProfile_TestingCalibrationDashboard_FilterActiveTab) + "&";
        if (userProfile_TestingCalibrationDashboard_FilterSearchText !== undefined && userProfile_TestingCalibrationDashboard_FilterSearchText !== null)
            url_ += "UserProfile.TestingCalibrationDashboard.FilterSearchText=" + encodeURIComponent("" + userProfile_TestingCalibrationDashboard_FilterSearchText) + "&";
        if (userProfile_PatternApprovalDashboard_FilterStatus !== undefined && userProfile_PatternApprovalDashboard_FilterStatus !== null)
            url_ += "UserProfile.PatternApprovalDashboard.FilterStatus=" + encodeURIComponent("" + userProfile_PatternApprovalDashboard_FilterStatus) + "&";
        if (userProfile_PatternApprovalDashboard_FilterYear !== undefined && userProfile_PatternApprovalDashboard_FilterYear !== null)
            url_ += "UserProfile.PatternApprovalDashboard.FilterYear=" + encodeURIComponent("" + userProfile_PatternApprovalDashboard_FilterYear) + "&";
        if (userProfile_PatternApprovalDashboard_FilterSortOrder !== undefined && userProfile_PatternApprovalDashboard_FilterSortOrder !== null)
            url_ += "UserProfile.PatternApprovalDashboard.FilterSortOrder=" + encodeURIComponent("" + userProfile_PatternApprovalDashboard_FilterSortOrder) + "&";
        if (userProfile_PatternApprovalDashboard_FiltersChanged !== undefined && userProfile_PatternApprovalDashboard_FiltersChanged !== null)
            url_ += "UserProfile.PatternApprovalDashboard.FiltersChanged=" + encodeURIComponent("" + userProfile_PatternApprovalDashboard_FiltersChanged) + "&";
        if (userProfile_PatternApprovalDashboard_FilterCurrentPage === null)
            throw new globalThis.Error("The parameter 'userProfile_PatternApprovalDashboard_FilterCurrentPage' cannot be null.");
        else if (userProfile_PatternApprovalDashboard_FilterCurrentPage !== undefined)
            url_ += "UserProfile.PatternApprovalDashboard.FilterCurrentPage=" + encodeURIComponent("" + userProfile_PatternApprovalDashboard_FilterCurrentPage) + "&";
        if (userProfile_PatternApprovalDashboard_FilterActiveTab !== undefined && userProfile_PatternApprovalDashboard_FilterActiveTab !== null)
            url_ += "UserProfile.PatternApprovalDashboard.FilterActiveTab=" + encodeURIComponent("" + userProfile_PatternApprovalDashboard_FilterActiveTab) + "&";
        if (userProfile_PatternApprovalDashboard_FilterSearchText !== undefined && userProfile_PatternApprovalDashboard_FilterSearchText !== null)
            url_ += "UserProfile.PatternApprovalDashboard.FilterSearchText=" + encodeURIComponent("" + userProfile_PatternApprovalDashboard_FilterSearchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetUserProfile(_response);
        });
    }

    protected processSetUserProfile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    address(signal?: AbortSignal): Promise<AddressDetailsDto> {
        let url_ = this.baseUrl + "/api/users/address";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddress(_response);
        });
    }

    protected processAddress(response: Response): Promise<AddressDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddressDetailsDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddressDetailsDto>(null as any);
    }

    attachment(signal?: AbortSignal): Promise<AttachmentDto> {
        let url_ = this.baseUrl + "/api/users/attachment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAttachment(_response);
        });
    }

    protected processAttachment(response: Response): Promise<AttachmentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AttachmentDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentDto>(null as any);
    }

    problem(signal?: AbortSignal): Promise<ValidationProblemDetails> {
        let url_ = this.baseUrl + "/api/users/problem";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProblem(_response);
        });
    }

    protected processProblem(response: Response): Promise<ValidationProblemDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationProblemDetails>(null as any);
    }
}

export class AcceptQuoteClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getStepStatuses(applicationId: string, signal?: AbortSignal): Promise<FormStepStatusDto[]> {
        let url_ = this.baseUrl + "/api/accept-quote/{ApplicationId}/step-statuses";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStepStatuses(_response);
        });
    }

    protected processGetStepStatuses(response: Response): Promise<FormStepStatusDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FormStepStatusDto[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormStepStatusDto[]>(null as any);
    }

    getReportRecipient(applicationId: string, signal?: AbortSignal): Promise<ReportRecipientStep> {
        let url_ = this.baseUrl + "/api/accept-quote/{ApplicationId}/report-recipient";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReportRecipient(_response);
        });
    }

    protected processGetReportRecipient(response: Response): Promise<ReportRecipientStep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportRecipientStep;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportRecipientStep>(null as any);
    }

    saveReportRecipient(applicationId: string, command: SaveReportRecipientCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/accept-quote/{ApplicationId}/report-recipient";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveReportRecipient(_response);
        });
    }

    protected processSaveReportRecipient(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDeliveryAndReturn(applicationId: string, signal?: AbortSignal): Promise<DeliveryAndReturnStep> {
        let url_ = this.baseUrl + "/api/accept-quote/{ApplicationId}/delivery-and-return";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeliveryAndReturn(_response);
        });
    }

    protected processGetDeliveryAndReturn(response: Response): Promise<DeliveryAndReturnStep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeliveryAndReturnStep;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeliveryAndReturnStep>(null as any);
    }

    saveDeliveryAndReturn(applicationId: string, command: SaveDeliveryAndReturnCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/accept-quote/{ApplicationId}/delivery-and-return";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveDeliveryAndReturn(_response);
        });
    }

    protected processSaveDeliveryAndReturn(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getPaymentDetails(applicationId: string, signal?: AbortSignal): Promise<PaymentDetailsStep> {
        let url_ = this.baseUrl + "/api/accept-quote/{ApplicationId}/payment-details";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPaymentDetails(_response);
        });
    }

    protected processGetPaymentDetails(response: Response): Promise<PaymentDetailsStep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentDetailsStep;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentDetailsStep>(null as any);
    }

    savePaymentDetails(applicationId: string, command: SavePaymentDetailsCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/accept-quote/{ApplicationId}/payment-details";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSavePaymentDetails(_response);
        });
    }

    protected processSavePaymentDetails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getSummaryAndAccept(applicationId: string, signal?: AbortSignal): Promise<SummaryAndAcceptStep> {
        let url_ = this.baseUrl + "/api/accept-quote/{ApplicationId}/summary-and-accept";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSummaryAndAccept(_response);
        });
    }

    protected processGetSummaryAndAccept(response: Response): Promise<SummaryAndAcceptStep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SummaryAndAcceptStep;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SummaryAndAcceptStep>(null as any);
    }

    saveSummaryAndAccept(applicationId: string, command: SaveSummaryAndAcceptCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/accept-quote/{ApplicationId}/summary-and-accept";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveSummaryAndAccept(_response);
        });
    }

    protected processSaveSummaryAndAccept(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    submit(applicationId: string, command: SubmitAcceptQuoteCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/accept-quote/{ApplicationId}/submit";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AccountsClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getNewAccountDetails(signal?: AbortSignal): Promise<GetAccountDto> {
        let url_ = this.baseUrl + "/api/forms/accounts/create-account/new";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNewAccountDetails(_response);
        });
    }

    protected processGetNewAccountDetails(response: Response): Promise<GetAccountDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAccountDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAccountDto>(null as any);
    }

    completeAccountDetails(command: SaveAccountCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/accounts/create-account/complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompleteAccountDetails(_response);
        });
    }

    protected processCompleteAccountDetails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAccountDetails(signal?: AbortSignal): Promise<GetAccountDto> {
        let url_ = this.baseUrl + "/api/forms/accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccountDetails(_response);
        });
    }

    protected processGetAccountDetails(response: Response): Promise<GetAccountDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAccountDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAccountDto>(null as any);
    }

    getBranchDetails(signal?: AbortSignal): Promise<GetAccountDto> {
        let url_ = this.baseUrl + "/api/forms/accounts/branch";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBranchDetails(_response);
        });
    }

    protected processGetBranchDetails(response: Response): Promise<GetAccountDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAccountDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAccountDto>(null as any);
    }

    completeBranchAdd(command: SaveAccountCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/accounts/branch-add/complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompleteBranchAdd(_response);
        });
    }

    protected processCompleteBranchAdd(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAccountDetailsByOrgId(organisationId: number, signal?: AbortSignal): Promise<GetAccountDto> {
        let url_ = this.baseUrl + "/api/forms/accounts/{OrganisationId}";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{OrganisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccountDetailsByOrgId(_response);
        });
    }

    protected processGetAccountDetailsByOrgId(response: Response): Promise<GetAccountDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAccountDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAccountDto>(null as any);
    }

    saveAccountDetails(command: SaveAccountCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/accounts/create-account/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveAccountDetails(_response);
        });
    }

    protected processSaveAccountDetails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class RequestForPatternApprovalClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getStepStatuses(applicationId: string, signal?: AbortSignal): Promise<FormStepStatusDto[]> {
        let url_ = this.baseUrl + "/api/request-for-pattern-approval/{ApplicationId}/step-statuses";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStepStatuses(_response);
        });
    }

    protected processGetStepStatuses(response: Response): Promise<FormStepStatusDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FormStepStatusDto[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormStepStatusDto[]>(null as any);
    }

    getOrganisationAndContact(applicationId: string, signal?: AbortSignal): Promise<PatternApprovalOrgAndContact> {
        let url_ = this.baseUrl + "/api/request-for-pattern-approval/{ApplicationId}/organisation-and-contact";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrganisationAndContact(_response);
        });
    }

    protected processGetOrganisationAndContact(response: Response): Promise<PatternApprovalOrgAndContact> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PatternApprovalOrgAndContact;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatternApprovalOrgAndContact>(null as any);
    }

    saveOrganisationAndContact(applicationId: string, command: PatternApprovalSaveOrgAndContactCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/request-for-pattern-approval/{ApplicationId}/organisation-and-contact";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveOrganisationAndContact(_response);
        });
    }

    protected processSaveOrganisationAndContact(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getApplicationAndInstrument(applicationId: string, signal?: AbortSignal): Promise<ApplicationAndInstrumentStep> {
        let url_ = this.baseUrl + "/api/request-for-pattern-approval/{ApplicationId}/application-and-instrument";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetApplicationAndInstrument(_response);
        });
    }

    protected processGetApplicationAndInstrument(response: Response): Promise<ApplicationAndInstrumentStep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationAndInstrumentStep;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationAndInstrumentStep>(null as any);
    }

    saveApplicationAndInstrument(applicationId: string, command: SaveApplicationAndInstrumentCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/request-for-pattern-approval/{ApplicationId}/application-and-instrument";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveApplicationAndInstrument(_response);
        });
    }

    protected processSaveApplicationAndInstrument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getSupportingDocuments(applicationId: string, signal?: AbortSignal): Promise<SupportingDocumentsStep> {
        let url_ = this.baseUrl + "/api/request-for-pattern-approval/{ApplicationId}/supporting-documents";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSupportingDocuments(_response);
        });
    }

    protected processGetSupportingDocuments(response: Response): Promise<SupportingDocumentsStep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SupportingDocumentsStep;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportingDocumentsStep>(null as any);
    }

    saveSupportingDocuments(applicationId: string, command: SaveSupportingDocumentsCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/request-for-pattern-approval/{ApplicationId}/supporting-documents";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveSupportingDocuments(_response);
        });
    }

    protected processSaveSupportingDocuments(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    addDocument(applicationId: string | null | undefined, category: string | null | undefined, file: FileParameter | null | undefined, signal?: AbortSignal): Promise<SupportingDocumentsStep> {
        let url_ = this.baseUrl + "/api/request-for-pattern-approval/add-document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (applicationId !== null && applicationId !== undefined)
            content_.append("ApplicationId", applicationId.toString());
        if (category !== null && category !== undefined)
            content_.append("Category", category.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddDocument(_response);
        });
    }

    protected processAddDocument(response: Response): Promise<SupportingDocumentsStep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SupportingDocumentsStep;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportingDocumentsStep>(null as any);
    }

    addDocuments(applicationId: string | undefined, category: string | null | undefined, uploadId: string | null | undefined, files: FileParameter[] | undefined, fileNames: string | null | undefined, fileSizes: string | null | undefined, signal?: AbortSignal): Promise<SupportingDocumentsStep> {
        let url_ = this.baseUrl + "/api/request-for-pattern-approval/add-documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (applicationId === null || applicationId === undefined)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else
            content_.append("ApplicationId", applicationId.toString());
        if (category !== null && category !== undefined)
            content_.append("Category", category.toString());
        if (uploadId !== null && uploadId !== undefined)
            content_.append("UploadId", uploadId.toString());
        if (files === null || files === undefined)
            throw new globalThis.Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (fileNames !== null && fileNames !== undefined)
            content_.append("FileNames", fileNames.toString());
        if (fileSizes !== null && fileSizes !== undefined)
            content_.append("FileSizes", fileSizes.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddDocuments(_response);
        });
    }

    protected processAddDocuments(response: Response): Promise<SupportingDocumentsStep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SupportingDocumentsStep;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportingDocumentsStep>(null as any);
    }

    deleteDocument(applicationId: string | null | undefined, documentReference: string | null | undefined, signal?: AbortSignal): Promise<SupportingDocumentsStep> {
        let url_ = this.baseUrl + "/api/request-for-pattern-approval/delete-document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (applicationId !== null && applicationId !== undefined)
            content_.append("ApplicationId", applicationId.toString());
        if (documentReference !== null && documentReference !== undefined)
            content_.append("DocumentReference", documentReference.toString());

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteDocument(_response);
        });
    }

    protected processDeleteDocument(response: Response): Promise<SupportingDocumentsStep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SupportingDocumentsStep;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportingDocumentsStep>(null as any);
    }

    updateCategory(applicationId: string | null | undefined, documentReference: string | null | undefined, newCategory: string | null | undefined, signal?: AbortSignal): Promise<SupportingDocumentsStep> {
        let url_ = this.baseUrl + "/api/request-for-pattern-approval/update-category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (applicationId !== null && applicationId !== undefined)
            content_.append("ApplicationId", applicationId.toString());
        if (documentReference !== null && documentReference !== undefined)
            content_.append("DocumentReference", documentReference.toString());
        if (newCategory !== null && newCategory !== undefined)
            content_.append("NewCategory", newCategory.toString());

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCategory(_response);
        });
    }

    protected processUpdateCategory(response: Response): Promise<SupportingDocumentsStep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SupportingDocumentsStep;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportingDocumentsStep>(null as any);
    }

    getSummary(applicationId: string, signal?: AbortSignal): Promise<RequestForPatternApprovalSummary> {
        let url_ = this.baseUrl + "/api/request-for-pattern-approval/{ApplicationId}/summary";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSummary(_response);
        });
    }

    protected processGetSummary(response: Response): Promise<RequestForPatternApprovalSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequestForPatternApprovalSummary;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestForPatternApprovalSummary>(null as any);
    }

    getAppDetails(applicationId: string, signal?: AbortSignal): Promise<RequestForPatternApprovalAppDetails> {
        let url_ = this.baseUrl + "/api/request-for-pattern-approval/{ApplicationId}/app-details";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppDetails(_response);
        });
    }

    protected processGetAppDetails(response: Response): Promise<RequestForPatternApprovalAppDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequestForPatternApprovalAppDetails;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestForPatternApprovalAppDetails>(null as any);
    }

    getTimelineDetails(appId: string | undefined, pageSize: number | undefined, pageNumber: number | undefined, applicationId: string, signal?: AbortSignal): Promise<PagedListOfPatternApprovalTimelineDto> {
        let url_ = this.baseUrl + "/api/request-for-pattern-approval/{ApplicationId}/app-timeline?";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        if (appId === null)
            throw new globalThis.Error("The parameter 'appId' cannot be null.");
        else if (appId !== undefined)
            url_ += "AppId=" + encodeURIComponent("" + appId) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTimelineDetails(_response);
        });
    }

    protected processGetTimelineDetails(response: Response): Promise<PagedListOfPatternApprovalTimelineDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListOfPatternApprovalTimelineDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedListOfPatternApprovalTimelineDto>(null as any);
    }

    getAppMessages(applicationIdQuery: string | undefined, pageSize: number | undefined, pageNumber: number | undefined, filterMessages: FilterMessages | undefined, applicationIdPath: string, signal?: AbortSignal): Promise<RequestForPatternApprovalApplicationMessage> {
        let url_ = this.baseUrl + "/api/request-for-pattern-approval/{ApplicationId}/app-messages?";
        if (applicationIdPath === undefined || applicationIdPath === null)
            throw new globalThis.Error("The parameter 'applicationIdPath' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationIdPath));
        if (applicationIdQuery === null)
            throw new globalThis.Error("The parameter 'applicationIdQuery' cannot be null.");
        else if (applicationIdQuery !== undefined)
            url_ += "ApplicationId=" + encodeURIComponent("" + applicationIdQuery) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (filterMessages === null)
            throw new globalThis.Error("The parameter 'filterMessages' cannot be null.");
        else if (filterMessages !== undefined)
            url_ += "FilterMessages=" + encodeURIComponent("" + filterMessages) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppMessages(_response);
        });
    }

    protected processGetAppMessages(response: Response): Promise<RequestForPatternApprovalApplicationMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequestForPatternApprovalApplicationMessage;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestForPatternApprovalApplicationMessage>(null as any);
    }

    getAppMessageCount(applicationIdQuery: string | undefined, applicationIdPath: string, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/api/request-for-pattern-approval/{ApplicationId}/app-messages-count?";
        if (applicationIdPath === undefined || applicationIdPath === null)
            throw new globalThis.Error("The parameter 'applicationIdPath' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationIdPath));
        if (applicationIdQuery === null)
            throw new globalThis.Error("The parameter 'applicationIdQuery' cannot be null.");
        else if (applicationIdQuery !== undefined)
            url_ += "ApplicationId=" + encodeURIComponent("" + applicationIdQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppMessageCount(_response);
        });
    }

    protected processGetAppMessageCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    addAppMessage(applicationId: string | null | undefined, body: string | null | undefined, signal?: AbortSignal): Promise<Unit> {
        let url_ = this.baseUrl + "/api/request-for-pattern-approval/add-message";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (applicationId !== null && applicationId !== undefined)
            content_.append("ApplicationId", applicationId.toString());
        if (body !== null && body !== undefined)
            content_.append("body", body.toString());

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAppMessage(_response);
        });
    }

    protected processAddAppMessage(response: Response): Promise<Unit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Unit;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Unit>(null as any);
    }

    getAppDocuments(applicationId: string, signal?: AbortSignal): Promise<SupportingDocumentsStep> {
        let url_ = this.baseUrl + "/api/request-for-pattern-approval/{ApplicationId}/app-documents";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppDocuments(_response);
        });
    }

    protected processGetAppDocuments(response: Response): Promise<SupportingDocumentsStep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SupportingDocumentsStep;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportingDocumentsStep>(null as any);
    }

    commitAppDocuments(applicationId: string, command: RequestForPatternApprovalAppDocumentsCommand, signal?: AbortSignal): Promise<SupportingDocumentsStep> {
        let url_ = this.baseUrl + "/api/request-for-pattern-approval/{ApplicationId}/commit-app-documents";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCommitAppDocuments(_response);
        });
    }

    protected processCommitAppDocuments(response: Response): Promise<SupportingDocumentsStep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SupportingDocumentsStep;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportingDocumentsStep>(null as any);
    }

    submit(applicationId: string, command: SubmitRequestForPatternApprovalCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/request-for-pattern-approval/{ApplicationId}/submit";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class RequestForQuoteClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getStepStatuses(applicationId: string, signal?: AbortSignal): Promise<FormStepStatusDto[]> {
        let url_ = this.baseUrl + "/api/request-for-quote/{ApplicationId}/step-statuses";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStepStatuses(_response);
        });
    }

    protected processGetStepStatuses(response: Response): Promise<FormStepStatusDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FormStepStatusDto[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormStepStatusDto[]>(null as any);
    }

    getOrganisationAndContact(applicationId: string, signal?: AbortSignal): Promise<OrganisationAndContact> {
        let url_ = this.baseUrl + "/api/request-for-quote/{ApplicationId}/organisation-and-contact";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrganisationAndContact(_response);
        });
    }

    protected processGetOrganisationAndContact(response: Response): Promise<OrganisationAndContact> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationAndContact;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganisationAndContact>(null as any);
    }

    saveOrganisationAndContact(applicationId: string, command: SaveOrganisationAndContactCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/request-for-quote/{ApplicationId}/organisation-and-contact";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveOrganisationAndContact(_response);
        });
    }

    protected processSaveOrganisationAndContact(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getInstrumentAndRequest(applicationId: string, signal?: AbortSignal): Promise<InstrumentAndRequestStep> {
        let url_ = this.baseUrl + "/api/request-for-quote/{ApplicationId}/instrument-and-request";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInstrumentAndRequest(_response);
        });
    }

    protected processGetInstrumentAndRequest(response: Response): Promise<InstrumentAndRequestStep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstrumentAndRequestStep;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentAndRequestStep>(null as any);
    }

    saveInstrumentAndRequest(applicationId: string, command: SaveInstrumentAndRequestCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/request-for-quote/{ApplicationId}/instrument-and-request";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveInstrumentAndRequest(_response);
        });
    }

    protected processSaveInstrumentAndRequest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getSummary(applicationId: string, signal?: AbortSignal): Promise<RequestForQuoteSummary> {
        let url_ = this.baseUrl + "/api/request-for-quote/{ApplicationId}/summary";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSummary(_response);
        });
    }

    protected processGetSummary(response: Response): Promise<RequestForQuoteSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequestForQuoteSummary;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestForQuoteSummary>(null as any);
    }

    getSubmittedSummary(applicationId: string, signal?: AbortSignal): Promise<RequestForQuoteSummary> {
        let url_ = this.baseUrl + "/api/request-for-quote/{ApplicationId}/view-summary";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSubmittedSummary(_response);
        });
    }

    protected processGetSubmittedSummary(response: Response): Promise<RequestForQuoteSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequestForQuoteSummary;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestForQuoteSummary>(null as any);
    }

    submit(applicationId: string, command: SubmitRequestForQuoteCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/request-for-quote/{ApplicationId}/submit";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRequestOverview(query: RequestForQuoteOverviewQuery | null | undefined, signal?: AbortSignal): Promise<RequestOverviewDto[]> {
        let url_ = this.baseUrl + "/api/request-for-quote/overview?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRequestOverview(_response);
        });
    }

    protected processGetRequestOverview(response: Response): Promise<RequestOverviewDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequestOverviewDto[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestOverviewDto[]>(null as any);
    }
}

export interface MatchedAddressesDto {
    matches?: MatchedAddress[] | undefined;
}

export interface MatchedAddress {
    unqiueId?: string | undefined;
    displayText?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    suburb?: string | undefined;
    state?: State;
    postCode?: string | undefined;
    country?: string | undefined;
}

export enum State {
    ACT = "ACT",
    NSW = "NSW",
    TAS = "TAS",
    VIC = "VIC",
    QLD = "QLD",
    NT = "NT",
    SA = "SA",
    WA = "WA",
}

export interface ApplicationDto {
    id?: number | undefined;
    referenceId?: string | undefined;
    sourceReferenceId?: string | undefined;
    applicationType?: ApplicationType;
    applicationStatus?: ApplicationStatus;
    isSharedWithOrganisation?: boolean;
    submittedOn?: Date | undefined;
    submittedBy?: string | undefined;
    statusChangedOn?: Date | undefined;
    organisationId?: number;
    organisation?: OrganisationDto | undefined;
    userId?: number | undefined;
    applicationContacts?: ContactDto[] | undefined;
}

export enum ApplicationType {
    QuoteRequest = "QuoteRequest",
    QuoteAccept = "QuoteAccept",
    PatternApproval = "PatternApproval",
}

export enum ApplicationStatus {
    Draft = "Draft",
    Submitted = "Submitted",
    Deleted = "Deleted",
}

export interface OrganisationDto {
    organisationId?: number;
    abn?: string | undefined;
    name?: string | undefined;
    businessOrTradingName?: string | undefined;
    branchOrLocationName?: string | undefined;
    businessEmailAddress?: string | undefined;
    businessWebsiteAddress?: string | undefined;
    streetAddress?: AddressDetailsDto | undefined;
    postalAddress?: AddressDetailsDto | undefined;
    acceptedTermsOfUse?: boolean;
    accountCompleted?: boolean;
    crmGuid?: string | undefined;
    isCompleted?: boolean;
    postalAddressSameAsStreetAddress?: boolean;
    businessListName?: string | undefined;
}

export interface AddressDetailsDto {
    id?: number;
    type?: number;
    line1?: string | undefined;
    line2?: string | undefined;
    line3?: string | undefined;
    suburb?: string | undefined;
    postcode?: string | undefined;
    state?: State | undefined;
    isManuallyEntered?: boolean;
    searchText?: string | undefined;
    timeStamp?: string | undefined;
}

export interface ContactDto {
    id?: number;
    title?: Title | undefined;
    titleOther?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    role?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    isCompleted?: boolean;
    crmGuid?: string | undefined;
    userId?: number | undefined;
    timeStamp?: string | undefined;
}

export enum Title {
    Mr = "Mr",
    Mrs = "Mrs",
    Miss = "Miss",
    Ms = "Ms",
    Dr = "Dr",
    Sir = "Sir",
    AssociateProfessor = "AssociateProfessor",
    Professor = "Professor",
    Constable = "Constable",
    SeniorConstable = "SeniorConstable",
    DetectiveSeniorConstable = "DetectiveSeniorConstable",
    Sergeant = "Sergeant",
    SeniorSergeant = "SeniorSergeant",
    DetectiveSergeant = "DetectiveSergeant",
    Other = "Other",
}

export interface CreateApplicationCommand {
    applicationType: ApplicationType | undefined;
    referenceId?: string | undefined;
}

export interface CopyApplicationCommand {
    applicationType: ApplicationType | undefined;
    referenceId?: string | undefined;
}

export interface DeleteApplicationCommand {
    applicationType: ApplicationType | undefined;
    referenceId?: string | undefined;
}

export interface ContactFormStep {
    contact?: ContactStep | undefined;
    formStepStatus?: FormStepStatus;
}

export interface ContactStep {
    title?: Title | undefined;
    titleOther?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    role?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    formStepStatus?: FormStepStatus;
}

export enum FormStepStatus {
    NotStarted = "NotStarted",
    Saved = "Saved",
    Completed = "Completed",
}

export interface GetFormStepQuery2OfContactFormStep {
}

export interface GetUserContactQuery extends GetFormStepQuery2OfContactFormStep {
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface HttpValidationProblemDetails extends ProblemDetails {
    errors?: { [key: string]: string[]; };

    [key: string]: any;
}

export interface ValidationProblemDetails extends HttpValidationProblemDetails {
    errors?: { [key: string]: string[]; };

    [key: string]: any;
}

export interface UpdateFormStepCommand2OfContactFormStep {
    formStep: ContactFormStep | undefined;
    isCompletingStep?: boolean;
}

export interface SaveContactCommand extends UpdateFormStepCommand2OfContactFormStep {
}

export interface DashboardItemDto {
    status?: string | undefined;
    lastUpdated?: Date | undefined;
    created?: Date | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    requestedFor?: string | undefined;
    referenceId?: string | undefined;
    sourceReferenceId?: string | undefined;
    requestForQuote?: RequestForQuoteDto | undefined;
    quote?: DashboardQuoteDto | undefined;
    report?: ReportDto | undefined;
    artefact?: InstrumentArtefactDto | undefined;
}

export interface RequestForQuoteDto {
    crmId?: string | undefined;
    id?: number;
    manufacturer?: string | undefined;
    serialNumber?: string | undefined;
    hasSerialNumber?: boolean | undefined;
    overview?: string | undefined;
    description?: string | undefined;
    model?: string | undefined;
    numberOfItems?: number | undefined;
    measurementCategoryId?: string | undefined;
    instrumentOrArtefactTypeId?: string | undefined;
    preferredInstrumentOrArtefactAvailabilityDate?: Date | undefined;
    previousQuoteOrReportNumber?: string | undefined;
    testingAndCalibrationRequirements?: string | undefined;
    measurementReportAndCertificateRequired?: string | undefined;
    status?: string | undefined;
    artefactType?: string | undefined;
    artefactName?: string | undefined;
    measurementCategory?: string | undefined;
    requestSubmitted?: Date | undefined;
    contactDetails?: RequestContactDetailsDto | undefined;
    isClone?: boolean | undefined;
    isClonedFrom?: string | undefined;
    isClonedFromRef?: string | undefined;
    clonedReferenceIds?: string[];
    hideFromDashboard?: boolean | undefined;
    clonedPortalOrganisationId?: string | undefined;
    measurementReportRequired?: string | undefined;
    portalAbn?: string | undefined;
}

export interface RequestContactDetailsDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    businessPhone?: string | undefined;
    mobilePhone?: string | undefined;
    title?: string | undefined;
    role?: string | undefined;
}

export interface DashboardQuoteDto {
    crmId?: string | undefined;
    dateRequired?: Date | undefined;
    quotationId?: string | undefined;
    offerDate?: Date | undefined;
    validUntil?: Date | undefined;
    requestSubmitted?: Date | undefined;
    artefactName?: string | undefined;
    nmiContactDetails?: RequestContactDetailsDto | undefined;
}

export interface ReportDto {
    crmId?: string | undefined;
    invoiceNumber?: string | undefined;
    dateRequired?: Date | undefined;
    dateReceived?: Date | undefined;
    reportId?: string | undefined;
    dateIssued?: Date | undefined;
    targetReportDate?: Date | undefined;
    returnMethod?: string | undefined;
    dateDispatched?: Date | undefined;
    carrier?: string | undefined;
    consignmentNote?: string | undefined;
}

export interface InstrumentArtefactDto {
    tmasTcInstrumentsArtefactsReportsId?: string;
    tmasName?: string | undefined;
    tmasPortalOrganisationId?: string | undefined;
    tmasRequestedFor?: string | undefined;
    tmasArtefactId?: string | undefined;
    tmasArtefactName?: string | undefined;
    tmasTcReportId?: string | undefined;
    tmasTcReportName?: string | undefined;
    tmasTcReportDate?: Date | undefined;
    tmasTcReportCreateDate?: Date | undefined;
    tmasInstrumentArtefactDetails?: string | undefined;
    tmasIsReportIssuedLatest?: boolean | undefined;
    tmasTcQuoteId?: string | undefined;
    tmasTcQuoteName?: string | undefined;
    tmasMeasurementCategoryName?: string | undefined;
    tmasMeasurementReportCertificateRequired?: string | undefined;
    tmasTcPortalArtefactName?: string | undefined;
    tmasPortalRequestId?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    tmasStatus?: string | undefined;
}

export interface PagedListOfDashboardItemDto {
    currentPage?: number;
    items?: DashboardItemDto[];
    totalPages?: number;
    pageSize?: number;
    totalCount?: number;
}

export enum StatusEnumDto {
    Submitted = "Submitted",
    AwaitingClientInformation = "AwaitingClientInformation",
    QuoteNotRequired = "QuoteNotRequired",
    QuoteInProgress = "QuoteInProgress",
    QuoteAvailable = "QuoteAvailable",
    QuoteAccepted = "QuoteAccepted",
    ReportInProgress = "ReportInProgress",
    ReportIssued = "ReportIssued",
    QuoteExpired = "QuoteExpired",
    QuoteDeclined = "QuoteDeclined",
    QuoteClosed = "QuoteClosed",
    ArtefactReceived = "ArtefactReceived",
}

export interface PagedListOfInstrumentArtefactDto {
    currentPage?: number;
    items?: InstrumentArtefactDto[];
    totalPages?: number;
    pageSize?: number;
    totalCount?: number;
}

export interface DownloadedFileResponse {
    filename?: string | undefined;
    mimeType?: string | undefined;
    fileData?: string | undefined;
    fileSizeBytes?: number | undefined;
}

export interface LookupResponse {
    id?: string;
    label?: string | undefined;
    lookupName?: string | undefined;
    parentId?: string | undefined;
}

export enum CRMLookupTypes {
    ArtefectTypeArea = "ArtefectTypeArea",
    TCArtefactTypePortalCategory = "TCArtefactTypePortalCategory",
    TCPortalMeasurementCategory = "TCPortalMeasurementCategory",
    PAPortalCategory = "PAPortalCategory",
    PAPortalInstrumentType = "PAPortalInstrumentType",
}

export interface ServiceDto {
    serviceType?: ServiceType;
    title?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    meta?: string | undefined;
}

export enum ServiceType {
    TestingCalibration = "TestingCalibration",
    PatternApproval = "PatternApproval",
}

export interface InstrumentTypeContentDto {
    id?: number;
    instrumentTypeTitle?: string | undefined;
    instrumentTypeId?: string | undefined;
    instrumentCategoryTitle?: string | undefined;
    instrumentCategoryId?: string | undefined;
    requirements?: string | undefined;
    requirementsLink?: string | undefined;
    eligibleForOiml?: boolean | undefined;
}

export interface AllInfoPanelContentQuery {
}

export interface PagedListOfPatternApprovalDashboardDetailsDto {
    currentPage?: number;
    items?: PatternApprovalDashboardDetailsDto[];
    totalPages?: number;
    pageSize?: number;
    totalCount?: number;
}

export interface PatternApprovalDashboardDetailsDto {
    referenceId: string;
    portalReferenceId: string;
    title: string;
    status: string;
    statusDetail: string;
    summary: string;
    appliedFor: string;
    assessedAs: string;
    lastUpdated?: string | undefined;
    unreadMessageCount?: number | undefined;
}

export enum PatternApprovalStatusEnumDto {
    Submitted = "Submitted",
    InProgress = "InProgress",
    OnHold = "OnHold",
    Completed = "Completed",
}

export interface UploadProgress {
    uploadId?: string;
    status?: string;
    totalFiles?: number;
    completedFiles?: number;
    percent?: number;
    files?: FileProgress[];
}

export interface FileProgress {
    fileName?: string;
    status?: string;
    blobUrl?: string | undefined;
    error?: string | undefined;
    bytesUploaded?: number;
    totalBytes?: number;
}

export interface ProgressCancelDto {
    error?: string | undefined;
    message?: string | undefined;
}

export interface RequestForQuoteDetails {
    quoteRequestIdNum?: string | undefined;
    quotationIdNum?: string | undefined;
    crmQuoteRequestId?: string | undefined;
    crmQuoteId?: string | undefined;
    status?: string | undefined;
    quoteRequestStatus?: string | undefined;
    paymentTerms?: string | undefined;
    quotationOfferDate?: Date | undefined;
    quotationValidUntil?: Date | undefined;
    serialNumber?: string | undefined;
    manufacturer?: string | undefined;
    model?: string | undefined;
    description?: string | undefined;
    instrumentArtefactToBeCalibrated?: string | undefined;
    portalArtefactName?: string | undefined;
    feePayableAmount?: number | undefined;
    receiptandDispatchNA?: boolean | undefined;
    dateInstrumentRequiredNMI?: Date | undefined;
    targetDateMesurementReport?: Date | undefined;
    outcomeDate?: Date | undefined;
    nmiCheckedByName?: string | undefined;
    nmiCheckedByPhone?: string | undefined;
    nmiCheckedByEmail?: string | undefined;
    nmiCheckedByJobTitle?: string | undefined;
    nmiTestOfficerName?: string | undefined;
    nmiTestOfficerPhone?: string | undefined;
    nmiTestOfficerEmail?: string | undefined;
    nmiTestOfficerJobTitle?: string | undefined;
    nmiFacilityName?: string | undefined;
    nmiFacilityAddress?: string | undefined;
    nmiFacilityDeliveryInstructions?: string | undefined;
    servicesOffered?: string | undefined;
    specialConditions?: string | undefined;
    measurementReportCertificateRequired?: string | undefined;
    recipientName?: string | undefined;
    recipientEmail?: string | undefined;
    recipientOrganisation?: string | undefined;
    recipientAddressLine1?: string | undefined;
    recipientAddressLine2?: string | undefined;
    recipientAddressLine3?: string | undefined;
    recipientAddressSuburb?: string | undefined;
    recipientAddressState?: string | undefined;
    recipientAddressPostcode?: string | undefined;
    returnContactName?: string | undefined;
    returnContactEmail?: string | undefined;
    returnMethod?: string | undefined;
    returnAddressLine1?: string | undefined;
    returnAddressLine2?: string | undefined;
    returnAddressLine3?: string | undefined;
    returnAddressSuburb?: string | undefined;
    returnAddressState?: string | undefined;
    returnAddressPostcode?: string | undefined;
    returnOrganisationName?: string | undefined;
    carrierName?: string | undefined;
    carrierShipRef?: string | undefined;
    carrierContactName?: string | undefined;
    carrierContactPhone?: string | undefined;
    report?: ReportDto | undefined;
}

export interface UserDto {
    userId?: number;
    contactId?: number | undefined;
    issuer?: string | undefined;
    issuerUserId?: string | undefined;
    employerAbn?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    contact?: ContactDto | undefined;
    organisation?: OrganisationDto | undefined;
    acceptedTerms?: boolean;
    termsVersion?: number | undefined;
    defaultOrganisationId?: number | undefined;
    userProfile?: UserProfileDto | undefined;
}

export interface UserProfileDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    services?: ServicesOffered[];
    testingCalibrationDashboard?: TestingCalibrationDashboardDto | undefined;
    patternApprovalDashboard?: PatternApprovalDashboardDto | undefined;
}

export interface ServicesOffered {
    service?: ServiceType;
    isActive?: boolean;
    isDefault?: boolean;
}

export interface TestingCalibrationDashboardDto {
    filterStatusType?: string | undefined;
    filterYearType?: string | undefined;
    filterSortOrder?: string | undefined;
    filtersChanged?: boolean | undefined;
    filterCurrentPage?: number;
    filterActiveTab?: string | undefined;
    filterSearchText?: string | undefined;
}

export interface PatternApprovalDashboardDto {
    filterStatusType?: string | undefined;
    filterYearType?: string | undefined;
    filterSortOrder?: string | undefined;
    filtersChanged?: boolean | undefined;
    filterCurrentPage?: number;
    filterActiveTab?: string | undefined;
    filterSearchText?: string | undefined;
}

export interface SignInCommand {
}

export interface AcceptTermsAndConditionsCommand {
    termsVersion?: number;
}

export interface SetDefaultOrganisationCommand {
    defaultOrganisationId?: number;
    rfqId?: string | undefined;
}

export interface AttachmentDto {
    id?: string | undefined;
    documentReference?: string | undefined;
    attachmentModifiedDate?: Date | undefined;
    attachmentMimeType?: string | undefined;
    attachmentType?: string | undefined;
    attachmentCategory?: string | undefined;
    attachmentName?: string | undefined;
    attachmentSize?: string | undefined;
    attachmentUrl?: string | undefined;
    attachmentAuthor?: string | undefined;
    attachmentPortalUsername?: string | undefined;
    attachmentOrigin?: string | undefined;
    attachmentCreatedDate?: Date | undefined;
    uploadDate?: Date | undefined;
    attachmentPublishedStatus?: string | undefined;
    parentTimestamp?: string | undefined;
    documentLocked?: boolean;
    documentBytes?: string | undefined;
}

export interface FormStepStatusDto {
    status?: FormStepStatus;
    crmQuoteRequestId?: string | undefined;
}

export interface ReportRecipientStep {
    organisationDifferent?: YesNo | undefined;
    rfqHide?: boolean | undefined;
    organisationNameHide?: boolean | undefined;
    organisationName?: string | undefined;
    businessStreetAddress?: AddressDetailsDto | undefined;
    contact?: ContactStep | undefined;
    isRecipientMailingAddressSame?: boolean | undefined;
    recipientMailingAddress?: AddressDetailsDto | undefined;
    reportAddressType?: ReportAddressTypeValues | undefined;
    acceptQuotePreInfo?: AcceptQuotePreInfoDto | undefined;
    requestForQuote?: RequestForQuote | undefined;
    rfqOrganisation?: OrganisationDto | undefined;
    formStepStatus?: FormStepStatus;
}

export enum YesNo {
    Yes = "Yes",
    No = "No",
}

export enum ReportAddressTypeValues {
    BusinessAddress = "BusinessAddress",
    PostalAddress = "PostalAddress",
    Other = "Other",
}

export interface AcceptQuotePreInfoDto {
    quotationIdNum?: string | undefined;
    crmQuoteId?: string | undefined;
    crmQuoteRequestId?: string | undefined;
    dateInstrumentRequiredNMI?: string | undefined;
    feePayableAmount?: string | undefined;
    manufacturer?: string | undefined;
    model?: string | undefined;
    nmiCheckedByEmail?: string | undefined;
    nmiCheckedByJobTitle?: string | undefined;
    nmiCheckedByName?: string | undefined;
    nmiCheckedByPhone?: string | undefined;
    nmiFacilityAddress?: string | undefined;
    nmiFacilityDeliveryInstructions?: string | undefined;
    nmiFacilityName?: string | undefined;
    nmiTestOfficerEmail?: string | undefined;
    nmiTestOfficerJobTitle?: string | undefined;
    nmiTestOfficerName?: string | undefined;
    nmiTestOfficerPhone?: string | undefined;
    paymentTerms?: string | undefined;
    receiptAndDispatchNA?: boolean | undefined;
    quotationOfferDate?: string | undefined;
    quotationValidUntil?: string | undefined;
    quoteRequestIdNum?: string | undefined;
    quoteRequestStatus?: string | undefined;
    serialNumber?: string | undefined;
    status?: string | undefined;
    targetDateMesurementReport?: string | undefined;
    defaultStreetAddress?: AddressDetailsDto | undefined;
    defaultPostalAddress?: AddressDetailsDto | undefined;
}

export interface RequestForQuote {
    isPrincipalContact?: YesNo | undefined;
    isCorrectBranchOrLocation?: YesNo | undefined;
    contact?: ContactStep | undefined;
    instrumentAndRequest?: InstrumentAndRequestStep | undefined;
}

export interface InstrumentAndRequestStep {
    sourceReferenceId?: string | undefined;
    hasSerialNumber?: YesNo | undefined;
    serialNumber?: string | undefined;
    manufacturer?: string | undefined;
    model?: string | undefined;
    description?: string | undefined;
    numberOfItems?: number | undefined;
    measurementCategory?: string | undefined;
    instrumentOrArtefactType?: string | undefined;
    preferredInstrumentOrArtefactAvailabilityDate?: Date | undefined;
    previousQuoteOrReportNumber?: string | undefined;
    testingAndCalibrationRequirements?: string | undefined;
    measurementReportAndCertificateRequired?: MeasurementReportAndCertificateRequiredValues | undefined;
    formStepStatus?: FormStepStatus;
}

export enum MeasurementReportAndCertificateRequiredValues {
    MeasurementReportOnly = "MeasurementReportOnly",
    Regulation13Only = "Regulation13Only",
    Regulation13WithMeasurementReport = "Regulation13WithMeasurementReport",
    Regulation34cOnly = "Regulation34cOnly",
    Regulation34cWithMeasurementReport = "Regulation34cWithMeasurementReport",
    UnsurePleaseAdvise = "UnsurePleaseAdvise",
}

export interface UpdateFormStepCommand2OfReportRecipientStep {
    formStep: ReportRecipientStep | undefined;
    isCompletingStep?: boolean;
}

export interface SaveReportRecipientCommand extends UpdateFormStepCommand2OfReportRecipientStep {
    applicationId: string;
}

export interface DeliveryAndReturnStep {
    rfqHide?: boolean | undefined;
    contactHide?: boolean | undefined;
    carrierHide?: boolean | undefined;
    contact?: ContactStep | undefined;
    returnContactType?: ReturnContactTypeValues | undefined;
    returnMethod?: ReturnMethodValues | undefined;
    returnAddressType?: ReturnAddressTypeValues | undefined;
    returnAddress?: AddressDetailsDto | undefined;
    returnOrganisationName?: string | undefined;
    packagingNotes?: string | undefined;
    carrierName?: string | undefined;
    carrierAccountNumber?: string | undefined;
    carrierContactPerson?: string | undefined;
    carrierContactPhone?: string | undefined;
    shipmentMode?: ShipmentModeValues | undefined;
    shipmentPriority?: ShipmentPriorityValues | undefined;
    insuranceNotes?: string | undefined;
    customsValue?: number | undefined;
    specialInstructions?: string | undefined;
    acceptQuotePreInfo?: AcceptQuotePreInfoDto | undefined;
    requestForQuote?: RequestForQuote | undefined;
    rfqOrganisation?: OrganisationDto | undefined;
    formStepStatus?: FormStepStatus;
}

export enum ReturnContactTypeValues {
    SamePerson = "SamePerson",
    DifferentPerson = "DifferentPerson",
}

export enum ReturnMethodValues {
    ClientToArrange = "ClientToArrange",
    ClientWillCollect = "ClientWillCollect",
    ClientWillProvide = "ClientWillProvide",
}

export enum ReturnAddressTypeValues {
    BusinessAddress = "BusinessAddress",
    PostalAddress = "PostalAddress",
    Other = "Other",
}

export enum ShipmentModeValues {
    Air = "Air",
    Road = "Road",
}

export enum ShipmentPriorityValues {
    SameDay = "SameDay",
    NextDay = "NextDay",
    Standard = "Standard",
    OffPeak = "OffPeak",
    Economy = "Economy",
    Express = "Express",
    Overnight = "Overnight",
    OvernightFirstClassPriority = "OvernightFirstClassPriority",
    Priority = "Priority",
}

export interface UpdateFormStepCommand2OfDeliveryAndReturnStep {
    formStep: DeliveryAndReturnStep | undefined;
    isCompletingStep?: boolean;
}

export interface SaveDeliveryAndReturnCommand extends UpdateFormStepCommand2OfDeliveryAndReturnStep {
    applicationId: string;
}

export interface PaymentDetailsStep {
    rfqHide?: boolean | undefined;
    purchaseOrderNo?: string | undefined;
    contactHide?: boolean | undefined;
    contact?: ContactStep | undefined;
    invoiceSentTo?: InvoiceSentToValues | undefined;
    acceptQuotePreInfo?: AcceptQuotePreInfoDto | undefined;
    requestForQuote?: RequestForQuote | undefined;
    rfqOrganisation?: OrganisationDto | undefined;
    formStepStatus?: FormStepStatus;
}

export enum InvoiceSentToValues {
    SamePerson = "SamePerson",
    DifferentPerson = "DifferentPerson",
}

export interface UpdateFormStepCommand2OfPaymentDetailsStep {
    formStep: PaymentDetailsStep | undefined;
    isCompletingStep?: boolean;
}

export interface SavePaymentDetailsCommand extends UpdateFormStepCommand2OfPaymentDetailsStep {
    applicationId: string;
}

export interface SummaryAndAcceptStep {
    referenceId?: string | undefined;
    associatedDisputes?: YesNo | undefined;
    associatedDispute?: string | undefined;
    acceptanceOfQuote?: boolean | undefined;
    reportRecipient?: ReportRecipientStep | undefined;
    deliveryAndReturn?: DeliveryAndReturnStep | undefined;
    paymentDetails?: PaymentDetailsStep | undefined;
    acceptQuotePreInfo?: AcceptQuotePreInfoDto | undefined;
    requestForQuote?: RequestForQuote | undefined;
    rfqOrganisation?: OrganisationDto | undefined;
    formStepStatus?: FormStepStatus;
}

export interface UpdateFormStepCommand2OfSummaryAndAcceptStep {
    formStep: SummaryAndAcceptStep | undefined;
    isCompletingStep?: boolean;
}

export interface SaveSummaryAndAcceptCommand extends UpdateFormStepCommand2OfSummaryAndAcceptStep {
    applicationId: string;
}

export interface SubmitAcceptQuoteCommand extends UpdateFormStepCommand2OfSummaryAndAcceptStep {
    applicationId: string;
}

export interface FormStepDtoOfGetAccountValuesDto {
    id?: number;
    steps?: FormStepStatusDto[] | undefined;
    stepValues?: GetAccountValuesDto | undefined;
    isFormComplete?: boolean;
}

export interface GetAccountDto extends FormStepDtoOfGetAccountValuesDto {
}

export interface BaseAccountDto {
    abn?: string | undefined;
    name?: string | undefined;
    businessOrTradingName?: string | undefined;
    branchOrLocationName?: string | undefined;
    isDefaultOrganisation?: boolean | undefined;
    businessWebsiteAddress?: string | undefined;
    businessEmailAddress?: string | undefined;
    crmGuid?: string | undefined;
    isCompleted?: boolean;
    accountCompleted?: boolean;
    contact?: ContactDto | undefined;
    streetAddress?: AddressDetailsDto | undefined;
    postalAddressSameAsStreetAddress?: boolean;
    postalAddress?: AddressDetailsDto | undefined;
}

export interface AccountDto extends BaseAccountDto {
    id?: number;
    timestamp?: string | undefined;
}

export interface GetAccountValuesDto extends AccountDto {
    status?: FormStepStatus;
    orgNameOptions?: OrgNameOption[] | undefined;
}

export interface OrgNameOption {
    orgName?: string | undefined;
    tradingName?: string | undefined;
    branchName?: string | undefined;
}

export interface UpdateFormStepCommand2OfSaveAccountDto {
    formStep: SaveAccountDto | undefined;
    isCompletingStep?: boolean;
}

export interface SaveAccountCommand extends UpdateFormStepCommand2OfSaveAccountDto {
    isNewAccount?: boolean;
    isAddBranch?: boolean;
}

export interface SaveAccountDto extends AccountDto {
    formStepStatus?: FormStepStatus;
}

export interface PatternApprovalOrgAndContact {
    sourceReferenceId?: string | undefined;
    abn?: string | undefined;
    name?: string | undefined;
    businessOrTradingName?: string | undefined;
    branchOrLocationName?: string | undefined;
    businessWebsiteAddress?: string | undefined;
    streetAddress?: AddressDetailsDto | undefined;
    authorisedAgent?: AuthorisedAgent | undefined;
    principalContactHide?: boolean | undefined;
    principalInvoiceContactHide?: boolean | undefined;
    isManufacturerHide?: boolean | undefined;
    isCurrentOrganisationHide?: boolean | undefined;
    isManufacturer?: YesNo | undefined;
    isPrincipalContact?: YesNo | undefined;
    isCorrectBranchOrLocation?: YesNo | undefined;
    isPrincipalInvoiceContact?: YesNo | undefined;
    contact?: ContactStep | undefined;
    currentContact?: ContactStep | undefined;
    invoiceContact?: ContactStep | undefined;
    organisationCount?: number | undefined;
    formStepStatus?: FormStepStatus;
}

export interface AuthorisedAgent {
    manufacturerName?: string | undefined;
    companyIdentifier?: string | undefined;
    streetAddress?: AddressDetailsDto | undefined;
    abn?: string | undefined;
}

export interface UpdateFormStepCommand2OfPatternApprovalOrgAndContact {
    formStep: PatternApprovalOrgAndContact | undefined;
    isCompletingStep?: boolean;
}

export interface PatternApprovalSaveOrgAndContactCommand extends UpdateFormStepCommand2OfPatternApprovalOrgAndContact {
    applicationId: string;
}

export interface ApplicationAndInstrumentStep {
    sourceReferenceId?: string | undefined;
    patternApprovalType?: PatternApprovalRequiredValues | undefined;
    newSubOptions?: PatternApprovalRequiredValueOptions[];
    varSubOptions?: PatternApprovalRequiredValueOptions[];
    othSubOptions?: PatternApprovalRequiredValueOptions[];
    instrumentCategory?: string | undefined;
    instrumentType?: string | undefined;
    isApplNewHide?: boolean | undefined;
    isApplNewInstrumentHide?: boolean | undefined;
    isApplVariationHide?: boolean | undefined;
    isApplOtherHide?: boolean | undefined;
    isApplOIMLHide?: boolean | undefined;
    certificateNumber?: string | undefined;
    certificateNumberId?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    summary?: string | undefined;
    formStepStatus?: FormStepStatus;
}

export enum PatternApprovalRequiredValues {
    Amendment = "Amendment",
    Cancellation = "Cancellation",
    NewCertificate = "NewCertificate",
    Variation = "Variation",
    OtherApproval = "OtherApproval",
}

export enum PatternApprovalRequiredValueOptions {
    CertificateofApproval = "CertificateofApproval",
    OIMLCertificate = "OIMLCertificate",
    VariationtoanExistingCoA = "VariationtoanExistingCoA",
    AmendmenttoanExistingCoA = "AmendmenttoanExistingCoA",
    ProvisionalCertificate = "ProvisionalCertificate",
    ConversionCertificate = "ConversionCertificate",
    ReviewofApproval = "ReviewofApproval",
    Consultation = "Consultation",
    WithdrawCertificate = "WithdrawCertificate",
    CertificateCancellation = "CertificateCancellation",
}

export interface UpdateFormStepCommand2OfApplicationAndInstrumentStep {
    formStep: ApplicationAndInstrumentStep | undefined;
    isCompletingStep?: boolean;
}

export interface SaveApplicationAndInstrumentCommand extends UpdateFormStepCommand2OfApplicationAndInstrumentStep {
    applicationId: string;
}

export interface SupportingDocumentsStep {
    form?: SupportingDocumentsForm | undefined;
    formStepStatus?: FormStepStatus;
    uploadId?: string | undefined;
}

export interface SupportingDocumentsForm {
    documents?: AttachmentDto[];
    instrumentCategory?: string | undefined;
    createdBy?: string | undefined;
    modifiedDate?: Date | undefined;
    instrumentType?: string | undefined;
    applicationStatus?: string | undefined;
    patternApprovalType?: PatternApprovalRequiredValues | undefined;
}

export interface UpdateFormStepCommand2OfSupportingDocumentsStep {
    formStep: SupportingDocumentsStep | undefined;
    isCompletingStep?: boolean;
}

export interface SaveSupportingDocumentsCommand extends UpdateFormStepCommand2OfSupportingDocumentsStep {
    applicationId: string;
}

export interface RequestForPatternApprovalSummary {
    referenceId?: string | undefined;
    previousPortalRefIdGUID?: string | undefined;
    previousPortalRefId?: string | undefined;
    acceptNMIP106?: boolean | undefined;
    acceptTermsAndConditions?: boolean | undefined;
    acceptDeclaration?: boolean | undefined;
    organisationAndContact?: PatternApprovalOrgAndContact | undefined;
    applicationAndInstrument?: ApplicationAndInstrumentStep | undefined;
    supportingDocuments?: SupportingDocumentsStep | undefined;
    formStepStatus?: FormStepStatus;
}

export interface RequestForPatternApprovalAppDetails {
    applicationDetails?: ApplicationDetailsDto | undefined;
    organisationAndContact?: PatternApprovalOrgAndContact | undefined;
    applicationAndInstrument?: ApplicationAndInstrumentStepDto | undefined;
    supportingDocuments?: SupportingDocumentsStep | undefined;
}

export interface ApplicationDetailsDto {
    referenceId: string;
    title: string;
    status: string;
    statusDetail: string;
    summary: string;
    appliedFor: string;
    assessedAs: string;
    certificateNumber?: string | undefined;
    lastUpdated?: string | undefined;
    submittedDate?: string | undefined;
    patternApprovalType?: string | undefined;
    messageCount?: number | undefined;
}

export interface ApplicationAndInstrumentStepDto extends ApplicationAndInstrumentStep {
    certNameOptions?: LookupResponse[];
    instrumentCategoryLookup?: LookupResponse[];
    instrumentTypeLookup?: LookupResponse[];
    instrumentTypeContent?: InstrumentTypeContentDto[];
}

export interface PagedListOfPatternApprovalTimelineDto {
    currentPage?: number;
    items?: PatternApprovalTimelineDto[];
    totalPages?: number;
    pageSize?: number;
    totalCount?: number;
}

export interface PatternApprovalTimelineDto {
    id?: string | undefined;
    subject?: string | undefined;
    modifiedOn?: Date | undefined;
    createdOn?: Date | undefined;
    status?: string | undefined;
    createdBy?: string | undefined;
    description?: string | undefined;
    regardingId?: string | undefined;
    message?: string | undefined;
    avatar?: string | undefined;
    messageRead?: boolean | undefined;
    owner?: string | undefined;
    isEventUserInitiated?: boolean;
}

export interface RequestForPatternApprovalApplicationMessage {
    patternApprovalId?: string;
    patternApprovalName?: string | undefined;
    requestForPatternApprovalMessageDetails?: PagedListOfRequestForPatternApprovalMessageDetails;
}

export interface PagedListOfRequestForPatternApprovalMessageDetails {
    currentPage?: number;
    items?: RequestForPatternApprovalMessageDetails[];
    totalPages?: number;
    pageSize?: number;
    totalCount?: number;
}

export interface RequestForPatternApprovalMessageDetails {
    id?: string;
    regardingId?: string;
    subject?: string | undefined;
    body?: string | undefined;
    footer?: string | undefined;
    avatar?: string | undefined;
    senderName?: string | undefined;
    messageSent?: Date | undefined;
    messageRead?: boolean | undefined;
    messageFrom?: string | undefined;
}

export enum FilterMessages {
    ShowAllMessages = "ShowAllMessages",
    ShowNmiMessages = "ShowNmiMessages",
    ShowPortalMessages = "ShowPortalMessages",
}

/** Represents a void type, since Void is not a valid return type in C#. */
export interface Unit {
}

export interface RequestForPatternApprovalAppDocumentsCommand {
    applicationId?: string | undefined;
    form?: SupportingDocumentsForm | undefined;
}

export interface UpdateFormStepCommand2OfRequestForPatternApprovalSummary {
    formStep: RequestForPatternApprovalSummary | undefined;
    isCompletingStep?: boolean;
}

export interface SubmitRequestForPatternApprovalCommand extends UpdateFormStepCommand2OfRequestForPatternApprovalSummary {
    applicationId: string;
}

export interface OrganisationAndContact {
    sourceReferenceId?: string | undefined;
    abn?: string | undefined;
    name?: string | undefined;
    businessOrTradingName?: string | undefined;
    branchOrLocationName?: string | undefined;
    businessWebsiteAddress?: string | undefined;
    principalContactHide?: boolean | undefined;
    isPrincipalContact?: YesNo | undefined;
    isCorrectBranchOrLocation?: YesNo | undefined;
    contact?: ContactStep | undefined;
    currentContact?: ContactStep | undefined;
    organisationCount?: number | undefined;
    formStepStatus?: FormStepStatus;
}

export interface UpdateFormStepCommand2OfOrganisationAndContact {
    formStep: OrganisationAndContact | undefined;
    isCompletingStep?: boolean;
}

export interface SaveOrganisationAndContactCommand extends UpdateFormStepCommand2OfOrganisationAndContact {
    applicationId: string;
}

export interface UpdateFormStepCommand2OfInstrumentAndRequestStep {
    formStep: InstrumentAndRequestStep | undefined;
    isCompletingStep?: boolean;
}

export interface SaveInstrumentAndRequestCommand extends UpdateFormStepCommand2OfInstrumentAndRequestStep {
    applicationId: string;
}

export interface RequestForQuoteSummary {
    referenceId?: string | undefined;
    previousPortalRefIdGUID?: string | undefined;
    previousPortalRefId?: string | undefined;
    organisationAndContact?: OrganisationAndContact | undefined;
    instrumentAndRequest?: InstrumentAndRequestStep | undefined;
    formStepStatus?: FormStepStatus;
}

export interface UpdateFormStepCommand2OfRequestForQuoteSummary {
    formStep: RequestForQuoteSummary | undefined;
    isCompletingStep?: boolean;
}

export interface SubmitRequestForQuoteCommand extends UpdateFormStepCommand2OfRequestForQuoteSummary {
    applicationId: string;
}

export interface RequestOverviewDto {
    id?: number;
    overview?: string | undefined;
    referenceId?: string | undefined;
    sourceReferenceId?: string | undefined;
    status?: string | undefined;
    lastUpdated?: Date;
    requestedFor?: string | undefined;
    serialNumber?: string | undefined;
    manufacturer?: string | undefined;
    model?: string | undefined;
    description?: string | undefined;
    artefactType?: string | undefined;
    measurementCategory?: string | undefined;
    contact?: RequestContactDetailsDto | undefined;
}

export interface RequestForQuoteOverviewQuery {
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
/* eslint-disable @typescript-eslint/no-explicit-any */